import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointSection } from './components/PainPointSection';
import { SolutionSection } from './components/SolutionSection';
import { ChaptersSection } from './components/ChaptersSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTASection } from './components/FinalCTASection';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-gray-900 overflow-x-hidden selection:bg-burgundy selection:text-cream" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2045975310141496&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <PainPointSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <ChaptersSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <ForWhoSection data-id="element-8" />
      <BonusSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FinalCTASection data-id="element-13" />
      <Footer data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
    </main>;
}